var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex gap-2 text-primary mb-6" },
        [
          _c("v-icon", { attrs: { color: "primary", size: 20 } }, [
            _vm._v(" mdi-console "),
          ]),
          _c("span", { staticClass: "text-xl font-medium" }, [
            _vm._v(_vm._s(_vm.$t("salepage.header"))),
          ]),
        ],
        1
      ),
      _c("sale-page-basic"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }